import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import MovimentacaoLastMileHttp from '../../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  CustomPanel,
  ImageContainer,
  Loading,
  PageHeader,
  UploadFileBtn,
} from '../../../../../components'

function UploadCanhoto({ history, dispatch }) {
  const {
    location: {
      state: { canhoto_id, num_nf_canhoto },
    },
  } = history

  const [canhoto, setCanhoto] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [cacheKey, setCacheKey] = useState(Date.now())

  useEffect(() => {
    getCanhoto()
  }, [canhoto_id])

  const onUploadCompleted = async file_name => {
    try {
      await MovimentacaoLastMileHttp.updatePathCanhoto(canhoto_id, file_name)
      setCacheKey(Date.now())
      await getCanhoto()
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onDeleteCanhotoClicked = async () => {
    try {
      const path_array = canhoto.path_canhoto.split('/')
      const file_name = path_array[path_array.length - 1]
      await MovimentacaoLastMileHttp.deleteCanhotoFile(file_name)
      await MovimentacaoLastMileHttp.updatePathCanhoto(canhoto_id, null)
      setCanhoto({ ...canhoto, path_canhoto: null })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const getCanhoto = async () => {
    try {
      if (!canhoto_id)
        throw new Error('Volte na tela anterior para selecionar o Canhoto desejado')
      const fetchedCanhoto = await MovimentacaoLastMileHttp.getCanhotoById(canhoto_id)
      setCanhoto(fetchedCanhoto)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  return (
    <React.Fragment>
      <PageHeader>
        Upload Canhoto - Patrimônio &nbsp;
        <strong>{num_nf_canhoto || (canhoto ? canhoto.num_nf_canhoto : '')}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            {!isLoading && !canhoto.path_canhoto && (
              <div className="p-col-2" style={{ height: 50 }}>
                <UploadFileBtn
                  label="Upload Canhoto"
                  name="canhoto"
                  url={MovimentacaoLastMileHttp.urlUploadCanhoto(canhoto_id)}
                  onUploadCompleted={onUploadCompleted}
                />
              </div>
            )}
            <div className="p-col-12">
              {isLoading ? (
                <div className="text-center">
                  <Loading />
                </div>
              ) : canhoto.path_canhoto ? (
                <ImageContainer
                  imagePath={`${canhoto.path_canhoto}?t=${cacheKey}`}
                  alt="Canhoto"
                  onBtnDeleteClicked={onDeleteCanhotoClicked}
                />
              ) : null}
            </div>
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(UploadCanhoto))
